import { Message, AnyMessage, MessageType, PROTOCOL_VERSION } from './types';

export function generateId(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function createMessage<T>(type: MessageType, payload: T, replyTo?: string): Message<T> {
  return {
    v: PROTOCOL_VERSION,
    type,
    id: generateId(),
    ts: Date.now(),
    payload,
    ...(replyTo && { replyTo }),
  };
}

export function isValidMessage(msg: unknown): msg is AnyMessage {
  if (!msg || typeof msg !== 'object') return false;
  const m = msg as Partial<Message>;
  return (
    typeof m.v === 'number' &&
    typeof m.type === 'string' &&
    typeof m.id === 'string' &&
    typeof m.ts === 'number' &&
    m.payload !== undefined
  );
}

export function isHandshakeMessage(type: MessageType): boolean {
  return [MessageType.HELLO, MessageType.HELLO_ACK].includes(type);
}

export function isSupportedVersion(version: number): boolean {
  return version === PROTOCOL_VERSION;
}
